<div class="change-phone-dialog">
	<!-- STEP 1: CHANGE MOBILE PHONE NUMBER -->
	@if (this.step === 1) {
		<div class="change-phone-dialog-content">
			@if (this.mode === this.editProfileMode.mobilePhoneNumber) {
				<div class="flex-column-center change-phone-dialog-height-100">
					<h2 class="change-header" mat-dialog-title i18n="@@changeMobilePhone-changeMobileNumberTitle">
						Change Mobile Number
					</h2>
					<mat-divider class="mat-divider-change"></mat-divider>
					<mat-dialog-content>
						<app-contact-phone-type-form class="new-mobile-form-width" (userPhoneNumber)="updateUserPhone($event)">
						</app-contact-phone-type-form>
					</mat-dialog-content>
					<mat-dialog-actions class="row-right">
						<button
							mat-button
							mat-dialog-close
							class="secondary-button"
							i18n="@@changeMobilePhone-cancel"
							data-automation-id="change-phone-email-cancel-one-button"
						>
							Cancel
						</button>
						<button
							mat-button
							i18n="@@changeMobilePhone-changeMobileNumberButton"
							(click)="onChangeClicked()"
							[disabled]="!this.isNewMobileNumberNextDisabled"
							class="primary-button"
							data-automation-id="change-phone-number-button"
						>
							Change Mobile Number
						</button>
					</mat-dialog-actions>
				</div>
			}
			@if (this.mode === this.editProfileMode.email) {
				<div class="flex-column-center">
					<h2 class="change-header" mat-dialog-title i18n="@@changeMobilePhone-changeEmailTitle">Change Email</h2>
					<mat-divider class="mat-divider-change"></mat-divider>
					<mat-dialog-content>
						<mat-form-field subscriptSizing="dynamic" appearance="outline" class="new-mobile-form-width">
							<mat-label i18n="@@changePassword-email">Email</mat-label>
							<input matInput [formControl]="emailFormControl" data-automation-id="email-input" />
						</mat-form-field>
					</mat-dialog-content>
					<mat-dialog-actions class="row-right">
						<button
							mat-button
							mat-dialog-close
							class="secondary-button"
							i18n="@@changeMobilePhone-emailCancel"
							data-automation-id="change-phone-email-cancel-two-button"
						>
							Cancel
						</button>
						<button
							mat-button
							i18n="@@changeMobilePhone-changeEmailButton"
							(click)="onCheckEmail()"
							[disabled]="this.emailFormControl.invalid"
							class="primary-button"
							data-automation-id="change-email-button"
						>
							Change Email
						</button>
					</mat-dialog-actions>
				</div>
			}
		</div>
	}

	<!-- Email Error state -->
	@if (this.errorState) {
		<div>
			<div class="flex-column-center">
				<h2 class="change-header" mat-dialog-title i18n="@@changeMobilePhone-errorTitle">Email Error</h2>
				<mat-divider class="mat-divider-change"></mat-divider>
				<mat-dialog-content>
					<p i18n="@@changeMobilePhone-errorMessage">
						The email address is already in use by another account. Please try a different email.
					</p>
				</mat-dialog-content>
				<mat-dialog-actions class="row-center">
					<button
						mat-button
						class="primary-button"
						i18n="@@changeMobilePhone-errorBack"
						(click)="onBackClicked()"
						data-automation-id="change-email-back-button"
					>
						Back
					</button>
				</mat-dialog-actions>
			</div>
		</div>
	}

	<!-- STEP 2: NOTIFY VERIFICATION-->
	@if (this.step === 2) {
		<div>
			<div class="flex-column-center">
				<h2 class="change-header" mat-dialog-title i18n="@@changeMobilePhone-verificationRequiredTitle">
					Verification Required
				</h2>
				<mat-divider class="mat-divider-change"></mat-divider>
				<mat-dialog-content>
					@if (this.mode === this.editProfileMode.mobilePhoneNumber) {
						<p class="padding-24" i18n="@@changeMobilePhone-verifyPhoneMessage">
							You must verify the new phone number before the changes can be saved to your account.
						</p>
					}
					@if (this.mode === this.editProfileMode.email) {
						<p class="padding-24" i18n="@@changeMobilePhone-verifyEmailMessage">
							You must verify the new email before the changes can be saved to your account.
						</p>
					}
				</mat-dialog-content>
				<mat-dialog-actions class="row-right">
					<button
						mat-button
						mat-dialog-close
						class="secondary-button"
						i18n="@@changeMobilePhone-verifyCancel"
						data-automation-id="change-phone-email-cancel-three-button"
					>
						Cancel
					</button>
					<button
						mat-button
						(click)="requestVerificationCode()"
						class="primary-button"
						i18n="@@changeMobilePhone-sendVerificationCodeButton"
						data-automation-id="change-phone-email-send-verification-code-button"
					>
						Send Verification Code
					</button>
				</mat-dialog-actions>
			</div>
		</div>
	}

	<!-- STEP 3: VERIFY WITH CODE -->
	@if (this.step === 3) {
		<div>
			<h2 class="change-header" mat-dialog-title i18n="@@changeMobilePhone-verificationRequiredTitle">
				Verification Required
			</h2>
			<mat-divider class="mat-divider-change"></mat-divider>
			<div style="padding-top: 24px">
				@if (this.mode === this.editProfileMode.mobilePhoneNumber) {
					<p class="content-message-no-padding" i18n="@@changeMobilePhone-smsSentToMessage">
						SMS sent to {{ this.newMobilePhoneNumber | phoneNumber }}
					</p>
				}
				@if (this.mode === this.editProfileMode.email) {
					<p class="content-message-no-padding" i18n="@@changeMobilePhone-emailSentToMessage">
						Email sent to {{ this.emailFormControl.value }}
					</p>
				}
			</div>
			<mat-dialog-content class="padding-24 margin-bottom-24">
				<p
					class="content-message-large"
					style="margin-bottom: 24px"
					i18n="@@changeMobilePhone-enterVerificationCodeMessage"
				>
					Please enter the 6-digit verification code
				</p>
				<app-verification-code
					(verificationCodeEventResult)="verificationCodeEventResult($event)"
					[userId]="this.userId"
					[mobilePhoneNumber]="this.newMobilePhoneNumber?.rawPhoneNumber"
					[mode]="this.mode"
					[newEmail]="this.emailFormControl.value"
				>
				</app-verification-code>
			</mat-dialog-content>
			<mat-dialog-actions class="row-right">
				<button
					mat-button
					(click)="onBackClicked()"
					class="secondary-button"
					i18n="@@changeMobilePhone-verificationRequiredBackButton"
					data-automation-id="change-phone-back-button"
				>
					Back
				</button>
				<button
					mat-button
					(click)="requestVerificationCode()"
					class="primary-button"
					i18n="@@changeMobilePhone-verificationRequiredResendCodeButton"
					data-automation-id="change-phone-email-resend-code-button"
				>
					Resend Code
				</button>
			</mat-dialog-actions>
		</div>
	}

	<!-- STEP 4: SUCCESS -->
	@if (this.step === 4) {
		<div>
			<h2 class="change-header" mat-dialog-title i18n="@@changeMobilePhone-verificationCompleteTitle">
				Verification Complete
			</h2>
			<mat-divider class="mat-divider-change"></mat-divider>
			<div class="padding-24-no-left">
				<p class="content-message-no-padding" i18n="@@changeMobilePhone-successfullyUpdated">
					Your account has been successfully updated and saved.
				</p>
			</div>
			<mat-dialog-actions style="float: right">
				<button
					mat-button
					class="primary-button"
					style="min-width: unset"
					(click)="onConfirmedClicked()"
					i18n="@@changeMobilePhone-confirmButton"
					data-automation-id="change-phone-email-confirm-button"
				>
					Confirm
				</button>
			</mat-dialog-actions>
		</div>
	}

	<!-- STEP 5: ERROR -->
	@if (this.step === 5) {
		<div>
			<h2
				class="change-header"
				mat-dialog-title
				i18n="@@changeMobilePhone-changeMobilePhone"
				class="warning-red"
				i18n="@@changeMobilePhone-verificationErrorTitle"
			>
				Verification Error
			</h2>
			<mat-divider class="mat-divider-change"></mat-divider>
			<div class="padding-24-no-left">
				<p class="content-message-no-padding warning-red" i18n="@@changeMobilePhone-verificationErrorMessage">
					The code is incorrect or has expired.
				</p>
			</div>
			<mat-dialog-actions style="float: right">
				<button
					mat-button
					(click)="onCancelClicked()"
					class="secondary-button"
					style="min-width: unset"
					i18n="@@changeMobilePhone-cancelButton"
					data-automation-id="change-phone-email-cancel-four-button"
				>
					Cancel
				</button>
				<button
					mat-button
					(click)="onRetryClicked()"
					class="primary-button"
					style="min-width: unset"
					i18n="@@changeMobilePhone-retryButton"
					data-automation-id="change-phone-email-retry-button"
				>
					Retry
				</button>
			</mat-dialog-actions>
		</div>
	}
</div>
